import React, { useState, useCallback } from 'react';

interface SearchBarProps {
	onSearch: (query: string) => void;
	placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, placeholder = 'Ara...' }) => {
	const [query, setQuery] = useState('');

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;
			setQuery(value);
			onSearch(value);
		},
		[onSearch]
	);

	return (
		<div className="search-container">
			<span className="icons-minimalistic-magnifer"></span>
			<input
				type="text"
				className="search-input"
				placeholder={placeholder}
				value={query}
				onChange={handleChange}
			/>
		</div>
	);
};

export default SearchBar;
